<template>
  <section style="margin-top:100px;">
    <div class="container">
      <h3 class="titulo">Parámetros</h3>
      <div class="row" style="justify-content: center">
        <div
          class="card categoria"
          style="background-color:grey; cursor: pointer"
          @click="accederCursos()"
        >
          <div class="card-body">
            <h3 class="text-white">Cursos</h3>
          </div>
        </div>


        <div
          class="card categoria"
          style="background-color:grey; cursor: pointer"
          @click="accederCategorias()"
        >
          <div class="card-body">
            <h3 class="text-white">Categorias</h3>
          </div>
        </div>

        <div
          class="card categoria"
          style="background-color:grey; cursor: pointer"
          @click="accederAdminNiveles()"
        >
          <div class="card-body">
            <h3 class="text-white">Niveles</h3>
          </div>
        </div>
        <div
          class="card categoria"
          style="background-color:grey; cursor: pointer"
          @click="accederAdminPuntajes()"
        >
          <div class="card-body">
            <h3 class="text-white">Puntajes</h3>
          </div>
        </div>
      </div>
    </div>

    <hr>
    <div class="container">
      <h3 class="titulo">Aprobaciones</h3>
      <div class="row" style="justify-content: center">




        <div
          class="card categoria"
          style="background-color:grey; cursor: pointer"
          @click="accederAdminMessages()"
        >
          <div class="card-body">
            <h3 class="text-white">Mensajes</h3>
          </div>
        </div>
        <div
          class="card categoria"
          style="background-color:grey; cursor: pointer"
          @click="accederAdminChallenge()"
        >
          <div class="card-body">
            <h3 class="text-white">Challenges</h3>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "app",
  data() {
    return {};
  },
  methods: {
    accederCategorias() {
      this.$router.push({ path: "/Categorias" });
    },
    accederCursos() {
      this.$router.push({ path: "/Cursos" });
    },
    accederAdminChallenge() {
      this.$router.push({ path: "/AprobarChallenge" });
    },
    accederAdminMessages() {
      this.$router.push({ path: "/AprobarMensajes" });
    },
    accederAdminPuntajes() {
      this.$router.push({ path: "/Puntajes" });
    },
    accederAdminNiveles() {
      this.$router.push({ path: "/Niveles" });
    }
  },
  computed: {},
  components: {},

  mounted: function() {}
};
</script>


// WEBPACK FOOTER //
// src/components/admin/AdminPanel.vue